// extracted by mini-css-extract-plugin
export default {"providers":"GenerateBonusReportPopup_providers__gjNQ0"};